import currency from 'currency.js';
import { useEffect, useState } from 'react';

export const usePasswordValidation = (
  password: string,
  minLength = 0,
  minSymbol = 0,
  submitted: boolean,
) => {
  const [validLength, setValidLength] = useState<boolean | null>(null);
  const [validSymbol, setValidSymbol] = useState<boolean | null>(null);
  const [allValid, setAllValid] = useState<boolean | null>(null);

  useEffect(() => {
    const validLengthCheck = password.length >= minLength ? true : false;
    const validSymbolCheck =
      password.replace(/[^ `!@#$%^&*()_+\-=\]{};':"\\|,.<>?~]/g, '').length >=
      minSymbol;

    if (submitted) {
      setValidLength(null);
      setValidSymbol(null);
      setAllValid(null);
    } else {
      setValidLength(validLengthCheck);
      setValidSymbol(validSymbolCheck);
      setAllValid(validLengthCheck && validSymbolCheck);
    }
  }, [password, minLength, minSymbol, submitted]);

  return {
    validLength,
    validSymbol,
    allValid,
  };
};
export const confirmPasswordMatch = (
  firstPassword: string,
  secondPassword: string,
) => {
  const [match, setMatch] = useState<boolean | null>(null);

  useEffect(() => {
    setMatch(!!firstPassword && firstPassword === secondPassword);
  }, [firstPassword, secondPassword]);

  return match;
};

export const numberStringTocommaString: (str: string) => string | undefined = (
  str,
) => {
  if (str !== '') {
    return parseInt(str).toLocaleString();
  } else {
    return undefined;
  }
};

export const formatCurrency =  (amount: any) => {
  if (isNaN(amount) || amount == null || amount == 0) {
    return '—';
  }
    const formatCurrency = currency(amount, {
    symbol: '$',
    precision: 2,
  }).format();

   return formatCurrency;
};

/**
 * Sort an array to ensure a specific value appears last in the list

 */
export const sortWithValueLast = <T extends Record<string, any>>(
  array: T[],
  displayValueKey: keyof T,
  lastValue: string
): T[] => {
  return array.sort((a, b) => {
    const aValue = a[displayValueKey];
    const bValue = b[displayValueKey];

    if (typeof aValue === 'string' && aValue.toLowerCase() === lastValue.toLowerCase()) {
      return 1;
    }
    if (typeof bValue === 'string' && bValue.toLowerCase() === lastValue.toLowerCase()) {
      return -1;
    }
    return 0;
  });
};
